import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { secondaryMarketQuoteRequestThunk } from 'state/secondaryMarket/realtimeQuote/quote/quote.thunks';
import {
  getSecondaryMarketRtFormErrorMessage,
  getSecondaryMarketRtFormQuoteId,
} from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import { getIsUserInternal } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import { AppState } from 'state/state.model';
import { getProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.selector';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  isUserInternal: boolean;
  rowId: string;
  errorMessage: string | undefined;
  quoteId?: string;
}>;

type DispatchProps = Readonly<{
  onGetQuote: () => void;
}>;

export type QuoteErrorSidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const rowId = getProductKey(state, tabId);
  const quoteId = getSecondaryMarketRtFormQuoteId(state, tabId) as string;
  return {
    isUserInternal: getIsUserInternal(state),
    errorMessage: getSecondaryMarketRtFormErrorMessage(state, tabId),
    rowId,
    quoteId,
  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps) => {
  return {
    onGetQuote() {
      dispatch(secondaryMarketQuoteRequestThunk(tabId));
      logAnalytics.trackEvent('Secondary market', 'Request for quote');
    },
  };
};

export const connectQuoteErrorSidePanel = connect(mapStateToProps, mapDispatchToProps);
